import { ColumnDescription } from "react-bootstrap-table-next";
import Table from "../../../../Components/Table";
import {
    AtualizarRenegociacaoAnaliseController,
    GetRenegociacaoAnaliseController,
} from "../../../../Controllers/Cobranca/AprovacaoRenegociacoes/AprovacaoRenegociacoesController";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import moment from "moment";
import { Dispatch, SetStateAction } from "react";
import { formatMoneyReais } from "../../../../Tools/FormatTools";

interface IRenegociacaoAnaliseProps {
    ID_CASO_COBRANCA_NEGOCIACAO_ANALISE: number;
    updateList: () => void;
    DS_STATUS: string;
    setShow: Dispatch<SetStateAction<boolean>>;
    visualizarListagem: boolean | undefined;
}

export default function RenegociacaoModal(props: IRenegociacaoAnaliseProps) {
    // const { reset } = FormMethods;

    const { value: lstRenegociacoes, loading: lstRenegociacoesLoading } =
        useAsyncEffect(async () => {
            return GetRenegociacaoAnaliseController(
                props.ID_CASO_COBRANCA_NEGOCIACAO_ANALISE
            );
        }, []);

    const { execute: atualizarRenegociacao } = useAsyncCallback(
        AtualizarRenegociacaoAnaliseController
    );

    const handleAprovarOuReprovar = (status: string) => {
        atualizarRenegociacao(
            props.ID_CASO_COBRANCA_NEGOCIACAO_ANALISE,
            status
        ).then(() => {
            props.updateList();
            props.setShow(false);
        });
    };

    return (
        <>
            <>
                <div className="card card-custom w-auto gutter-b m-5">
                    {props.visualizarListagem && (
                        <div className="react-bootstrap-table mw-100 custom-scroll">
                            <h3>Resultado: </h3>
                            <table className="table table-striped v-middle-cells">
                                <thead>
                                    <tr>
                                        <th
                                            tabIndex={0}
                                            style={{ textAlign: "center" }}
                                        ></th>
                                        <th
                                            tabIndex={0}
                                            style={{ textAlign: "center" }}
                                        >
                                            Usuário Responsável
                                        </th>
                                        <th
                                            tabIndex={0}
                                            style={{ textAlign: "center" }}
                                        >
                                            Status
                                        </th>
                                        <th
                                            tabIndex={0}
                                            style={{ textAlign: "center" }}
                                        >
                                            Dt. Aprovação Renegociação
                                        </th>
                                        <th
                                            tabIndex={0}
                                            style={{ textAlign: "center" }}
                                        >
                                            Acréscimo
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="rowClasses">
                                        <td
                                            style={{ textAlign: "center" }}
                                        ></td>
                                        <td style={{ textAlign: "center" }}>
                                            {
                                                lstRenegociacoes?.DS_USUARIO_RESPONSAVEL
                                            }
                                        </td>
                                        <td style={{ textAlign: "center" }}>
                                            {lstRenegociacoes?.DS_STATUS}
                                        </td>
                                        <td style={{ textAlign: "center" }}>
                                            {lstRenegociacoes?.DT_APROVACAO_NEGOCIACAO ??
                                                "-"}
                                        </td>
                                        <td style={{ textAlign: "center" }}>
                                            {formatMoneyReais(
                                                lstRenegociacoes?.VL_ACRESCIMO ??
                                                    0
                                            ) ?? "-"}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
                <div className="card card-custom w-auto gutter-b m-5">
                    <h3>Lista de Parcelas Antigas: </h3>
                    <Table
                        wrapperClasses="mw-100 custom-scroll"
                        columns={tableviewColumns}
                        data={lstRenegociacoes?.LISTA_PARCELAS_ANTIGA || []}
                        keyField="ID_CASO_COBRANCA_NEGOCIACAO_ANALISE_PARCELAS_NEGOCIADAS"
                        remote={{ pagination: false }}
                        loading={lstRenegociacoesLoading}
                        noDataIndication={() => (
                            <div className="text-black-50 text-center">
                                Nenhuma parcela antiga encontrada
                            </div>
                        )}
                        noPagination
                        noHover
                        noSearch
                        bordered={false}
                        classes="v-middle-cells"
                        defaultStyle={{ align: "center" }}
                        striped={true}
                        rowClasses={"rowClasses"}
                    />
                </div>
                <div className="card card-custom w-auto gutter-b m-5">
                    <h3>Lista de Parcelas Renegociação: </h3>
                    <Table
                        wrapperClasses="mw-100 custom-scroll"
                        columns={tableviewColumnsRenegociacao}
                        data={
                            lstRenegociacoes?.LISTA_PARCELAS_RENEGOCIACAO || []
                        }
                        keyField="ID_CASO_COBRANCA_NEGOCIACAO_ANALISE_PARCELA"
                        remote={{ pagination: false }}
                        loading={lstRenegociacoesLoading}
                        noDataIndication={() => (
                            <div className="text-black-50 text-center">
                                Nenhuma parcela de renegociação encontrada
                            </div>
                        )}
                        noPagination
                        noHover
                        noSearch
                        bordered={false}
                        classes="v-middle-cells"
                        defaultStyle={{ align: "center" }}
                        striped={true}
                        rowClasses={"rowClasses"}
                    />
                </div>
                {!props.visualizarListagem && (
                    <div className="d-flex justify-content-around">
                        <button
                            className="btn btn-sm btn-shadow btn-primary d-flex align-items-center justify-content-center w-25 mb-4"
                            onClick={() => handleAprovarOuReprovar("APROVADO")}
                        >
                            Aprovar Renegociação
                        </button>
                        <button
                            className="btn btn-sm btn-shadow btn-danger d-flex align-items-center justify-content-center w-25 mb-4"
                            onClick={() => handleAprovarOuReprovar("REPROVADO")}
                        >
                            Reprovar Renegociação
                        </button>
                    </div>
                )}
            </>
        </>
    );
}

const tableviewColumns: Array<ColumnDescription> = [
    {
        dataField: "DUMMY_FIELD",
        text: "",
        isDummyField: true,
    },
    {
        dataField: "DS_TIPO",
        text: "Tipo Parcela",
        align: "center",
    },
    {
        dataField: "NR_PARCELA",
        text: "NR Parcela",
        align: "center",
    },
    {
        dataField: "NR_PARCELA_GERAL",
        text: "NR Parcela Geral",
        align: "center",
    },
    {
        dataField: "VL_PARCELA",
        text: "Valor da Parcela",
        align: "center",
        formatter: (c) => formatMoneyReais(c),
    },
    {
        dataField: "DT_VENCIMENTO",
        text: "Data de Vencimento",
        align: "center",
        formatter: (c) => moment(c).format("DD/MM/yy"),
    },
];

const tableviewColumnsRenegociacao: Array<ColumnDescription> = [
    {
        dataField: "DUMMY_FIELD",
        text: "",
        isDummyField: true,
    },
    {
        dataField: "DS_TIPO_PARCELA",
        text: "Tipo Parcela",
        align: "center",
    },
    {
        dataField: "NR_PARCELA",
        text: "NR Parcela",
        align: "center",
    },
    {
        dataField: "NR_PARCELA_GERAL",
        text: "NR Parcela Geral",
        align: "center",
    },
    {
        dataField: "VL_PARCELA",
        text: "Valor da Parcela",
        align: "center",
        formatter: (c) => formatMoneyReais(c),
    },
    {
        dataField: "DT_VENCIMENTO",
        text: "Data de Vencimento",
        align: "center",
        formatter: (c) => moment(c).format("DD/MM/yy"),
    },
];
